// $(document).ready(function() {
//     // Configuration mapping section IDs to target positions
//     var carouselTargets = {
//         'featured_collection_86aV7w': 4,
//         'featured_collection_Jc4kbC': 5,
//         'featured_collection_jemUw3': 3
//     };
    
//     // Store original positions
//     var originalPositions = {};
    
//     // Initialize original positions for each carousel
//     $('[id*="featured_collection"]').each(function() {
//         var sectionId = $(this).attr('id');
//         var elementToMove = $(this).find('> div > cc-carousel > div.cc-carousel__scroll-outer > div > div');
        
//         if (elementToMove.length) {
//             originalPositions[sectionId] = {
//                 parent: elementToMove.parent(),
//                 index: elementToMove.index()
//             };
//         }
//     });
    
//     function moveElements() {
//         Object.keys(carouselTargets).forEach(function(collectionKey) {
//             var sectionId = $('[id*="' + collectionKey + '"]').attr('id');
//             if (!sectionId) return;
            
//             var elementToMove = $('#' + sectionId + ' > div > cc-carousel > div.cc-carousel__scroll-outer > div > div');
//             var targetChildIndex = carouselTargets[collectionKey];
//             var targetElement = $('#' + sectionId + ' > div > cc-carousel > div.cc-carousel__scroll-outer > div > product-block:nth-child(' + targetChildIndex + ')');
            
//             if (elementToMove.length && targetElement.length) {
//                 if ($(window).width() >= 1100) {
//                     elementToMove.insertBefore(targetElement);
//                 } else {
//                     // Restore original position
//                     var original = originalPositions[sectionId];
//                     if (original && original.index === 0) {
//                         elementToMove.prependTo(original.parent);
//                     } else if (original) {
//                         elementToMove.insertAfter(original.parent.children().eq(original.index - 1));
//                     }
//                 }
//             }
//         });
//     }
    
//     // Run on page load
//     moveElements();
    
//     // Run on window resize with debounce
//     var resizeTimer;
//     $(window).resize(function() {
//         clearTimeout(resizeTimer);
//         resizeTimer = setTimeout(moveElements, 250);
//     });
// });

$(document).ready(function() {
    // Configuration mapping section IDs to target positions
    var carouselTargets = {
        'featured_collection_86aV7w': 4,
        'featured_collection_Jc4kbC': 5,
        'featured_collection_jemUw3': 3
    };
    
    // Store original positions
    var originalPositions = {};
    var initialized = false;
    
    // Initialize original positions for each carousel
    function initializePositions() {
        if (initialized) return;
        
        $('[id*="featured_collection"]').each(function() {
            var sectionId = $(this).attr('id');
            var elementToMove = $(this).find('> div > cc-carousel > div.cc-carousel__scroll-outer > div > div');
            
            if (elementToMove.length) {
                originalPositions[sectionId] = {
                    parent: elementToMove.parent(),
                    index: elementToMove.index()
                };
            }
        });
        initialized = true;
    }
    
    function moveElements() {
        // Check if key elements exist before proceeding
        var hasElements = false;
        Object.keys(carouselTargets).forEach(function(collectionKey) {
            if ($('[id*="' + collectionKey + '"]').length > 0) {
                hasElements = true;
            }
        });
        
        if (!hasElements) {
            return; // Exit if no elements found
        }
        
        initializePositions();
        
        Object.keys(carouselTargets).forEach(function(collectionKey) {
            var sectionId = $('[id*="' + collectionKey + '"]').attr('id');
            if (!sectionId) return;
            
            var elementToMove = $('#' + sectionId + ' > div > cc-carousel > div.cc-carousel__scroll-outer > div > div');
            var targetChildIndex = carouselTargets[collectionKey];
            var targetElement = $('#' + sectionId + ' > div > cc-carousel > div.cc-carousel__scroll-outer > div > product-block:nth-child(' + targetChildIndex + ')');
            
            if (elementToMove.length && targetElement.length) {
                if ($(window).width() >= 1100) {
                    elementToMove.insertBefore(targetElement);
                } else {
                    // Restore original position
                    var original = originalPositions[sectionId];
                    if (original && original.index === 0) {
                        elementToMove.prependTo(original.parent);
                    } else if (original) {
                        elementToMove.insertAfter(original.parent.children().eq(original.index - 1));
                    }
                }
            }
        });
    }
    
    // Multiple execution strategy to handle different loading scenarios
    moveElements(); // Immediate
    setTimeout(moveElements, 200); // Short delay for additional rendering
    setTimeout(moveElements, 800); // Longer delay for lazy loading
    
    // After all resources load
    $(window).on('load', function() {
        setTimeout(moveElements, 100);
    });
    
    // Run on window resize with debounce
    var resizeTimer;
    $(window).resize(function() {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(moveElements, 250);
    });
});